/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setNotificationPreferences} from '../api'

export const useMutationSetNotificationPreferences = createReactQueryMutationHook('setNotificationPreferences', setNotificationPreferences)
